import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';

const Login = () => import('@/pages/auth/Login.vue');
const PasswordSetup = () => import('@/pages/auth/PasswordSetup.vue');
const TwoFactorChallenge = () => import('@/pages/auth/TwoFactorChallenge.vue');

export const authRoutes: AppRouteRecordRaw[] = [
  {
    path: '/auth',
    meta: {
      i18nModules: [ETranslationModule.auth, ETranslationModule.users],
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          title: 'Login | ryd Portal',
        },
      },
      {
        path: '2fa',
        name: 'twoFactorChallenge',
        component: TwoFactorChallenge,
        meta: {
          title: 'Two-Factor Authentication | ryd Portal',
        },
      },
      // {
      //   path: 'register',
      //   name: 'register',
      //   component: Register,
      //   meta: {
      //     title: ' Register | ryd Portal',
      //   },
      // },
      {
        path: 'password-setup',
        name: 'setPassword',
        component: PasswordSetup,
        meta: {
          title: 'Set Password | ryd Portal',
        },
      },
    ],
  },
];
